import { Injectable } from '@angular/core';

import { AuthService } from '@degreed/lxp/services/authorization';

@Injectable()
export class AuthGuardService {
  constructor(private authService: AuthService) {}

  public canActivate() {
    return this.checkLogin();
  }

  public canLoad(): boolean {
    return this.checkLogin();
  }

  public canMatch(): boolean {
    return this.checkLogin();
  }

  public checkLogin(): boolean {
    // Redirect to login url if not authenticated. This should instead use straight up routing once we have an Angular login route
    if (!this.authService.isLoggedIn) {
      this.authService.logout(false, true);
      return false;
    }
    return true;
  }
}
